import { useEffect, useState } from 'react';
import { useServerFn } from '@tanstack/react-start';
import { BellRing, LoaderCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { createPriceAlert } from '@/lib/comparison.functions';
import { useAuth } from '@/contexts/AuthContext';
import { enablePush, preparePush, pushResultMessage } from '@/lib/pushClient';

export function PriceAlertForm({ productId, dealId, current }: { productId?: string; dealId?: string; current: number }) {
  const { user } = useAuth();
  const save = useServerFn(createPriceAlert);
  const [email, setEmail] = useState('');
  const [website, setWebsite] = useState('');
  const [state, setState] = useState<{ ok?: boolean; msg?: string; busy?: boolean }>({});
  useEffect(() => { void preparePush(); }, []);
  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setState({ busy: true });
    try {
      const push = await enablePush();
      const pushToken = push.status === 'registered' ? push.token : null;
      const r = await save({ data: { productId, dealId, email: email || user?.email || '', current, pushToken, website } });
      if (!r.ok) return setState({ msg: r.error });
      const suffix = push.status === 'registered' ? ' por e-mail e notificação.' : ` por e-mail. ${pushResultMessage(push)}`;
      setState({ ok: true, msg: `Monitoramento ativado${suffix}` });
    } catch (err) { setState({ msg: (err as Error).message || 'Não foi possível salvar.' }); }
  };
  return <section aria-labelledby="alert-title" className="rounded-md border bg-card p-5 shadow-sm">
      <div><h2 id="alert-title" className="flex items-center gap-2 text-base font-bold"><BellRing className="h-5 w-5 text-primary" /> Monitore este produto</h2><p className="mt-1 text-sm text-muted-foreground">Avisaremos quando o preço ficar abaixo de {new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(current)}.</p></div>
      {state.ok ? <p role="status" className="mt-4 text-sm font-medium text-success">{state.msg}</p> : <form onSubmit={submit} className="mt-4 grid gap-2 sm:grid-cols-[minmax(0,1fr)_auto]">
        <label className="sr-only" htmlFor="alert-email">E-mail</label>
        {!user?.email ? <Input id="alert-email" type="email" required value={email} onChange={e => setEmail(e.target.value)} placeholder="Seu e-mail" /> : <p className="flex min-h-10 items-center truncate rounded-md border bg-muted/30 px-3 text-sm text-muted-foreground">{user.email}</p>}
        <input type="text" tabIndex={-1} autoComplete="off" aria-hidden="true" className="hidden" value={website} onChange={e => setWebsite(e.target.value)} />
        <Button type="submit" disabled={state.busy}>{state.busy && <LoaderCircle className="mr-2 h-4 w-4 animate-spin" />}Monitorar</Button>
      </form>}
      {state.msg && !state.ok && <p role="alert" className="mt-2 text-sm text-destructive">{state.msg}</p>}
  </section>;
}
